module.exports = __webpack_public_path__ + "img/swiper_01.941cba37.jpg";